import { render, staticRenderFns } from "./DynamicTree.vue?vue&type=template&id=20526c31"
import script from "./DynamicTree.vue?vue&type=script&lang=js"
export * from "./DynamicTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports